import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { callAgentService } from '../services/callAgentService';

// Async thunks for call agent template operations
export const fetchTemplates = createAsyncThunk(
  'callAgent/fetchTemplates',
  async (_, { rejectWithValue }) => {
    try {
      const response = await callAgentService.getAllTemplates();
      return response?.data || response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchTemplateById = createAsyncThunk(
  'callAgent/fetchTemplateById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await callAgentService.getTemplateById(id);
      return response
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const createTemplate = createAsyncThunk(
  'callAgent/createTemplate',
  async (template, { rejectWithValue }) => {
    try {
      const response = await callAgentService.createTemplate(template);
      return response
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateTemplate = createAsyncThunk(
  'callAgent/updateTemplate',
  async ({ id, template }, { rejectWithValue }) => {
    try {
      const response = await callAgentService.updateTemplate(id, template);
      return response
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteTemplate = createAsyncThunk(
  'callAgent/deleteTemplate',
  async (id, { rejectWithValue }) => {
    try {
      await callAgentService.deleteTemplate(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Slice
const callAgentSlice = createSlice({
  name: 'callAgent',
  initialState: {
    templates: [],
    selectedTemplate: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch templates
      .addCase(fetchTemplates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTemplates.fulfilled, (state, action) => {
        state.loading = false;
        state.templates = action.payload;
      })
      .addCase(fetchTemplates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch template by ID
      .addCase(fetchTemplateById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTemplateById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedTemplate = action.payload;
      })
      .addCase(fetchTemplateById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Create template
      .addCase(createTemplate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.templates.push(action.payload);
      })
      .addCase(createTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update template
      .addCase(updateTemplate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTemplate.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.templates.findIndex(t => t.id === action.payload.id || t._id === action.payload._id);
        if (index !== -1) {
          state.templates[index] = action.payload;
        }
      })
      .addCase(updateTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete template
      .addCase(deleteTemplate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.templates = state.templates.filter(t => t.id !== action.payload && t._id !== action.payload);
      })
      .addCase(deleteTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = callAgentSlice.actions;
export default callAgentSlice.reducer;